import { actAuthenticateUserSuccess, actLoginSuccess } from 'actions/loginStateActions';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { setCookie } from 'util/icwUtility';
import { Spin } from 'antd';

export default function VerifyAuth() {
  // dispatch(actAuthenticateUserSuccess());
  const dispatch = useDispatch();
  const searchParams = new URLSearchParams(window.location.search);
  const state = searchParams.get('state');
  if (state) {
    const config = JSON.parse(window.atob(state));
    if (config.token) {
      setCookie('token', config.token);
      setCookie('activated_user', true);
      dispatch(actAuthenticateUserSuccess());
      dispatch(actLoginSuccess());
      return (
        <Redirect
          to={{
            pathname: `/dashboard`,
          }}
        />
      );
    }
  }
  return <Spin spinning />;
}
